import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AbstractStateService } from '@libs/index';
import { StorageService } from '../storage/storage.service';
import { CookiesConfig } from '../../models/interfaces/CookiesConfig.interface';
import { UnfinishedBookingData } from '../../models/interfaces/UnfinishedBookingData.interface';
import { RwgData } from '../../models/interfaces/RwgData.interface';

@Injectable({
  providedIn: 'root',
})
export class StateService extends AbstractStateService {
  private cookiesConfig$$: BehaviorSubject<CookiesConfig>;
  public readonly cookiesConfig$: Observable<CookiesConfig>;

  private unfinishedBookingData$$: BehaviorSubject<UnfinishedBookingData>;
  public readonly unfinishedBookingData$: Observable<UnfinishedBookingData>;

  private rwgData$$: BehaviorSubject<RwgData>;
  public readonly rwgData$: Observable<RwgData>;

  public isClosedAgbHint: boolean;
  public isClosedContactUpdateDialog: boolean;

  constructor(protected storageService: StorageService) {
    super(storageService);

    this.cookiesConfig$$ = new BehaviorSubject<CookiesConfig>(null);
    this.cookiesConfig$ = this.cookiesConfig$$.asObservable();

    this.unfinishedBookingData$$ = new BehaviorSubject<UnfinishedBookingData>(
      this.storageService.getUnfinishedBookingData()
    );
    this.unfinishedBookingData$ = this.unfinishedBookingData$$.asObservable();

    this.rwgData$$ = new BehaviorSubject<RwgData>(
      this.storageService.getRwgData()
    );
    this.rwgData$ = this.rwgData$$.asObservable();
  }

  public clearWhenLogout(): void {
    this.setToken(null);
    this.setUser(null);
    this.setUnfinishedBookingData(null);
    this.clearMapOfBoIdAndUuidAuthResponse();
    this.isClosedAgbHint = false;
    this.isClosedContactUpdateDialog = false;
  }

  public getCookiesConfig(): CookiesConfig {
    return this.storageService.getCookiesConfig();
  }

  public setCookiesConfig(cookiesConfig: CookiesConfig): void {
    this.storageService.saveCookiesConfig(cookiesConfig);
    this.cookiesConfig$$.next(cookiesConfig);
  }

  public setUnfinishedBookingData(data: UnfinishedBookingData): void {
    if (!data) {
      this.storageService.removeUnfinishedBookingData();
    } else {
      this.storageService.saveUnfinishedBookingData(data);
    }

    this.unfinishedBookingData$$.next(data);
  }

  public setRwgData(data: RwgData): void {
    if (!data) {
      this.storageService.removeRwgData();
    } else {
      this.storageService.saveRwgData(data);
    }

    this.rwgData$$.next(data);
  }
}
